import React, { useEffect, useState } from 'react';
import { animated, useSpring } from '@react-spring/web';

import RichText from '../../../generic/RichText';
import SVGIcon from '../../../generic/SVGIcon';
import { ScrollToSeeMoreFullScreen } from '../../../generic/ScrollToSeeMore';
import { mergeClassNames } from '../../../../utils';
import styles from './index.module.scss';

const translateY = 400;

let defaultSection = {
  __typename: null,
  display: null,
  roomFeaturesMobile: null,
  roomFeatures: null,
  heading: null,
  mainFrame: null,
  icon: null,
};

export default function DeviceSection({ section = defaultSection, index, className = '', debug, pageChangeState }) {
  const { pageNum, pageNumDiff } = pageChangeState;

  const [active, setActive] = useState(() => index === pageNum);
  const [forward, setForward] = useState(() => pageNumDiff > 0);
  const [visible, setVisible] = useState(() => index === 0);

  const [textProps, setTextProps] = useSpring(() => ({
    opacity: active ? 1 : 0,
    transform: `translate(0px, 0px)`,
  }));

  useEffect(() => {
    setActive(index === pageNum);
    setForward(pageNumDiff > 0);
  }, [index, pageNum, pageNumDiff]);

  useEffect(() => {
    if (active === null) {
      return;
    }

    let fromLocation = -1;
    let targetLocation = -1;
    if (active) {
      fromLocation = forward ? translateY : -translateY;
      targetLocation = 0;
    } else {
      fromLocation = 0;
      targetLocation = forward ? -translateY : translateY;
    }
    setTextProps.start({
      delay: active ? 500 : 0,
      opacity: active ? 1 : 0,
      transform: `translate(0px,${targetLocation}px)`,
      from: { transform: `translate(0px,${fromLocation}px)` },
      immediate: false,
      onStart: () => {
        setVisible(true);
      },
      onRest: el => {
        setVisible(el?.value?.opacity === 1);
      },
    });
  }, [active, forward, setTextProps]);

  let sectionClass = mergeClassNames(
    styles[section.display ? section.display : 'Left'],
    styles[section.textPosition ? 'Top' : 'Center']
  );

  const heading = section.heading;

  return (
    <div id={`section${index}`} className={mergeClassNames(className, styles.deviceSection, debug ? styles.debug : '')}>
      {/* <img src={imageUrl} className={styles.image} /> */}
      {debug && `#${index} : ${section.display} : ${heading} frame:[${section.mainFrame}]`}
      <div className={mergeClassNames(styles.fixed, styles[visible ? 'active' : 'inactive'], sectionClass)}>
        <animated.div key={index} className={mergeClassNames(styles.animated, sectionClass)} style={textProps}>
          <div className={styles.text}>
            {section.icon && <SVGIcon className={styles.icon} svgIcon={section.icon} />}
            {heading && (section.display === 'Hero' ? <h3>{heading}</h3> : <h4>{heading}</h4>)}
            {section.description && <RichText>{section.description}</RichText>}
          </div>
        </animated.div>
        {index === 0 && <ScrollToSeeMoreFullScreen className={styles.scrollToSeeMore} invert />}
      </div>
    </div>
  );
}
